import { Box, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }
    render() {
        var _a;
        if (this.state.hasError) {
            return (React.createElement(Box, { sx: { display: 'flex' } },
                React.createElement(Tooltip, { title: ((_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error', arrow: true },
                    React.createElement(Typography, null, this.props.errorMessage ? this.props.errorMessage : 'Sorry.. there was an error'))));
        }
        return this.props.children;
    }
}
